import { CategoryResponse } from "api"
import styled from "styled-components"
import GiftcardType from "./GiftcardType"

const StyledStripContainer = styled.div`
  padding: 0 16px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 0 60px;
  }
`

const StyledGiftcardStripContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    gap: 48px;

    flex-wrap: wrap;
  }
`

const StyledTitle = styled.h2`
  color: var(--Black, var(--Primary-Black, #000));
  font-family: NarkisBlock;
  font-size: 26px;

  margin-bottom: 16px;
  text-align: right;
  font-weight: bold;
  margin-top: 0;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 24px;
    font-size: 32px;
    font-style: normal;
    line-height: normal;
  }
`

type GiftcardStripProps = {
  data: CategoryResponse[]
}

export type FixedItem = {
  name: string
  icon: {
    imageUrl: string
    alt: string
  }
  slug: string
}

const GiftcardTypeStrip = ({ data }: GiftcardStripProps) => {
  const fixedItems: FixedItem[] = [
    {
      name: "ברכה ב-AI",
      icon: {
        imageUrl: "/AI-property.png",
        alt: "ברכה ב-AI",
      },
      slug: "/create-ai",
    },
    {
      name: "רכישה קבוצתית",
      icon: {
        imageUrl: "/group-icon.png",
        alt: "רכישה קבוצתית",
      },
      slug: "/groupPurchases",
    },
  ]
  return (
    <StyledStripContainer>
      <StyledTitle>איזה גיפטקארד נשלח?</StyledTitle>
      <StyledGiftcardStripContainer>
        <GiftcardType key={10000} data={fixedItems[0]} isNotCategory />
        <GiftcardType key={10001} data={fixedItems[1]} isNotCategory />
        {data.map(
          (item, index) =>
            index !== 0 && <GiftcardType key={index} data={item} />
        )}
      </StyledGiftcardStripContainer>
    </StyledStripContainer>
  )
}

export default GiftcardTypeStrip
